<div *ngIf="iframeUrl" id="casino-frm">
  <div class="casino-detail-head">
      <button (click)="back()"> 
        <i class="fas fa-home"></i> 
        <!-- <img src="assets/img/{{env.host.name}}/logo.png" alt="Exchange" class="img-fluid logo"> -->
      </button>
      <h4>{{gameName}}</h4>
      <span><i class="fa fa-user"></i> {{userData?.username}}</span>
  </div>
  <iframe class="embed-responsive-item" scrolling="yes" [src]='iframeUrl | safeURL' allowfullscreen="true" title="game" id="casino-link"></iframe>
</div>


<app-loader *ngIf="isLoad" [isFpLoader]="false"></app-loader>
